import { FC } from 'react'
import { Tabs } from 'antd'
import { useTranslation } from 'react-i18next'
import PerFlexRow from '../../../components/custom_components/FlexRow'
import PerIcon from '../../../components/custom_components/Icon'
import PerText from '../../../components/custom_components/Text'
import { MonitoringTabs } from '../dasboardStoreTypes'

const { TabPane } = Tabs

type DashboardAppraisalMonitoringHeaderProps = {
  activeTab: MonitoringTabs
  onTabChange: (tab: MonitoringTabs) => void
  asYear: number | null | undefined
}

const DashboardAppraisalMonitoringHeader: FC<DashboardAppraisalMonitoringHeaderProps> = ({ activeTab, onTabChange, asYear }) => {
  const [t] = useTranslation()

  return (
    <PerFlexRow justify="space-between" align="middle" className="dashboard-appraisal-monitoring__header">
      <PerText fontWeight="bold" fontSize="m">
        {t('dashboard.companyManager.monitoring.header.title', { year: asYear ? asYear : '' })}
      </PerText>
      <Tabs
        className="dashboard-appraisal-monitoring__tabs"
        activeKey={activeTab}
        onChange={(key) => onTabChange(key as MonitoringTabs)}
        tabBarGutter={0}
        aria-label={t('dashboard.companyManager.monitoring.header.tabListAria')}
      >
        <TabPane key={MonitoringTabs.CHART} tab={<PerIcon name="dashboard_barChart" size={24} />} />
        <TabPane key={MonitoringTabs.TABLE} tab={<PerIcon name="dashboard_table" size={24} />} />
      </Tabs>
    </PerFlexRow>
  )
}

export default DashboardAppraisalMonitoringHeader
